module.exports = __webpack_public_path__ + "img/ic_arc.452e2c9d.svg";